import { CortexMark } from "./CortexMark";

// LoginPage is the signed-out screen. "Sign in with OFLIC" hands off to the
// backend /oauth/authorize route, which redirects to OFLIC's hosted login —
// no credentials are ever entered in this SPA.
export function LoginPage({ onSignIn }: { onSignIn: () => void }) {
  return (
    <div className="login">
      <div className="login-card">
        <CortexMark />
        <h1>Atlas Control</h1>
        <p className="lede">Development control room</p>
        <p className="login-copy">
          Sign in with your OBASHI OFLIC account to access the Cortex Atlas control room.
        </p>
        <button type="button" className="btn-primary" onClick={onSignIn}>
          Sign in with OFLIC
        </button>
      </div>
      <footer className="login-footer">
        Source of truth: OBASHITechnology/cortex-atlas · docs/
      </footer>
    </div>
  );
}
